import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import NotFound from '../../containers/NotFound';
import useLoggedUser from '../../hooks/useLoggedUser';
import usePermissions from '../../IAM/usePermissions';

const RequiresPermission = (props) => {
  const {
    children, selfException, idPath = 'id', permission = [],
  } = props;
  const { [idPath]: id } = useParams();
  const { loggedUser } = useLoggedUser();
  const permissions = usePermissions();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  const { id: userID, role } = loggedUser;

  if (!role) {
    return <NotFound />;
  }

  if (selfException && id) {
    if (userID === id) {
      return <>{children}</>;
    }
  }

  if (!(permissions.hasPermission(permission))) {
    return <NotFound />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

RequiresPermission.propTypes = {
  children: PropTypes.node,
};

export default RequiresPermission;
